import { httpRequest } from '~/adapters/httpRequest';
import { taskFrom } from '../transformers/task.transformer';

export interface ActionInputs {
  libraryActionId: number | null;
  surveyTypeId?: number | null;
  translations: { [langCode: string]: { title: string; description: string } };
  dueAt: string | null;
  surveyIds: number[] | null;
  userId: number;
  categoryIds: number[] | null;
}

const createAction = async (input: ActionInputs) => {
  try {
    const res = await httpRequest<any>('/action-planning/actions', {
      method: 'POST',
      body: {
        libraryActionId: input.libraryActionId,
        surveyTypeId: input.surveyTypeId,
        translations: input.translations,
        dueAt: input.dueAt,
        surveyIds: input.surveyIds ?? [],
        categoryIds: input.categoryIds ?? [],
        userIds: [input.userId],
      },
    });

    if (res.error) return Promise.reject(res.error);
    if (res?.errors) return Promise.reject(res.errors[0]);

    const task = taskFrom(res.payload);
    return task;
  } catch (e: any) {
    console.error(e?.message);
    throw e;
  }
};

export const actionsMutations = {
  createAction,
};
